import React from 'react';
import { createRoot } from 'react-dom/client';
import { MaintenancePage } from './MaintenancePage';

// Shell elements to strip before mounting — named so app/index.html changes only
// need an update here. Scoped to <body> children; analytics <script> tags are left alone.
const SHELL_SELECTOR = 'header, .container-fluid, iio-notifications';

/**
 * Replaces the Angular shell with the outage page. Angular is never bootstrapped
 * in this path, so the shell markup would otherwise sit there uncompiled.
 */
export function mountMaintenancePage(): void {
  document.body.querySelectorAll(SHELL_SELECTOR).forEach((el) => el.remove());

  const container = document.createElement('div');
  container.id = 'maintenance-root';
  document.body.prepend(container);
  createRoot(container).render(<MaintenancePage />);
}
